import { css, jsx } from '@emotion/react';
import PropTypes from 'prop-types';
import React from 'react';

const style = {
  container: css`
    margin-left: auto;
    margin-right: auto;
    padding-left: 16px;
    padding-right: 16px;
  `,
  size: {
    lg: css`
      max-width: 1200px;
    `,
    md: css`
      max-width: 1000px;
    `,
    sm: css`
      max-width: 800px;
    `,
  },
};

const Container = (props) => {
  const { children, size = 'lg', ..._props } = props;
  return <div css={[style.container, style.size[size]]} {..._props}>
    {children}
  </div>
};

Container.propTypes = {
  children: PropTypes.node.isRequired,
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  style: PropTypes.object,
};
Container.defaultProps = {
  size: 'lg',
};

export default Container;
